import { render, staticRenderFns } from "./ArchiveOpportunities.vue?vue&type=template&id=0d59e65d&scoped=true&"
import script from "./ArchiveOpportunities.vue?vue&type=script&lang=js&"
export * from "./ArchiveOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveOpportunities.vue?vue&type=style&index=0&id=0d59e65d&prod&lang=css&"
import style1 from "./ArchiveOpportunities.vue?vue&type=style&index=1&id=0d59e65d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d59e65d",
  null
  
)

export default component.exports